"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralSideEffects = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
const native_base_1 = require("native-base");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const FollowPrescription_style_1 = require("../FollowPrescription.style");
const atome_1 = require("../../../atome");
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const organisms_1 = require("../../../organisms");
const AbortFUPModal_1 = require("./AbortFUPModal");
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const lodash_1 = __importDefault(require("lodash"));
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
function GeneralSideEffects(props) {
    const { navigation, setCurrentPage, showFUPRModal, setShowFUPRModal } = props;
    const [groupValues, setGroupValues] = (0, react_1.useState)(['']);
    const prescriptionInfo = (0, hooks_1.useAppSelector)(reducers_1.selectPrescriptionInfo);
    const [prescriptionTemp, setPrescriptionTemp] = (0, react_1.useState)(prescriptionInfo);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [isButtonDisabled, setIsButtonDisabled] = (0, react_1.useState)(false);
    // validate inputs
    (0, react_1.useEffect)(() => {
        const nothingSelected = !prescriptionTemp.generalSideEffects.length;
        const otherSelectedAndNoOtherTextEntered2 = prescriptionTemp.generalSideEffects.includes('sonstiges') &&
            !prescriptionTemp?.generalSideEffectsOther?.length;
        const hasError = nothingSelected || otherSelectedAndNoOtherTextEntered2;
        hasError ? setIsButtonDisabled(true) : setIsButtonDisabled(false);
    }, [prescriptionTemp]);
    const handleBackButton = () => {
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 3,
            },
        };
        setCurrentPage(reducerType);
    };
    const next = () => {
        // remove generalSideEffectsOther text if Other='sonstiges' is not checked
        if (!prescriptionTemp?.generalSideEffects.includes('sonstiges')) {
            setPrescriptionTemp({
                ...prescriptionTemp,
                generalSideEffectsOther: '',
            });
        }
        dispatch((0, reducers_1.setPrescriptionInfo)(prescriptionTemp));
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 5,
            },
        };
        setCurrentPage(reducerType);
    };
    const handleCheckboxesChange = (value) => {
        console.log('handleCheckboxesChange', value);
        if (lodash_1.default.isArray(value)) {
            if (value.includes('keine')) {
                //@ts-ignore
                setGroupValues(['keine']);
            }
            else {
                setGroupValues(value);
            }
        }
    };
    const handleInputFieldChange = (value) => {
        console.log('handleInputFieldChange', value);
        setPrescriptionTemp({
            ...prescriptionTemp,
            generalSideEffectsOther: value,
        });
    };
    // set Libraries Groupvalue checkboxes in the Redux State
    (0, react_1.useEffect)(() => {
        setPrescriptionTemp({
            ...prescriptionTemp,
            generalSideEffects: groupValues,
        });
    }, [groupValues]);
    (0, react_1.useEffect)(() => {
        setGroupValues(prescriptionInfo.generalSideEffects);
    }, []);
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(atome_1.BetterScrollView, null,
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(native_base_1.VStack, { space: 5, style: GlobalStyles_1.globalStyles.mobileToWebContainer },
                react_1.default.createElement(native_base_1.Center, { mt: "20" },
                    react_1.default.createElement(native_base_1.Text, { fontSize: "2xl", textAlign: "center", fontWeight: "bold", color: "#3db384" }, "Allgemeine Nebenwirkungen")),
                react_1.default.createElement(native_base_1.Center, { mt: "3", mb: "3" },
                    react_1.default.createElement(native_base_1.Text, { textAlign: "center", w: "90%" }, "Bitte teilen Sie Ihrem behandelnden Arzt mit, ob im Rahmen Ihrer Cannabinoid-Therapie Nebenwirkungen und negative Erfahrungen aufgetreten sind.")),
                react_1.default.createElement(native_base_1.Checkbox.Group, { bgColor: "#f8f8f8", onChange: value => handleCheckboxesChange(value), value: groupValues, accessibilityLabel: "choose numbers" },
                    react_1.default.createElement(native_base_1.VStack, { space: 5, mt: "5", mb: "3", p: "5", w: '95%' },
                        react_1.default.createElement(native_base_1.Text, { fontWeight: "bold", mb: "1" }, "Allgemeine Nebenwirkungen"),
                        react_1.default.createElement(native_base_1.Checkbox, { borderColor: "#3db384", colorScheme: 'green', value: 'reactions' },
                            react_1.default.createElement(native_base_1.Text, { ml: 2 }, "Allergische Reaktionen / Unvertr\u00E4glichkeit")),
                        react_1.default.createElement(native_base_1.Checkbox, { borderColor: "#3db384", colorScheme: 'green', value: 'dryMouth' },
                            react_1.default.createElement(native_base_1.Text, { ml: 2 }, "Trockene Schleimh\u00E4ute (trockener Mund / ger\u00F6tete Augen)")),
                        react_1.default.createElement(native_base_1.Checkbox, { borderColor: "#3db384", colorScheme: 'green', value: 'appetite' },
                            react_1.default.createElement(native_base_1.Text, { ml: 2 }, "Gesteigerter Appetit (als unangenehmer Effekt)")),
                        react_1.default.createElement(native_base_1.Checkbox, { borderColor: "#3db384", colorScheme: 'green', value: 'nausea' },
                            react_1.default.createElement(native_base_1.Text, { ml: 2 }, "\u00DCbelkeit")),
                        react_1.default.createElement(native_base_1.Checkbox, { borderColor: "#3db384", colorScheme: 'green', value: 'increasedFatigue' },
                            react_1.default.createElement(native_base_1.Text, { ml: 2 }, "Erh\u00F6hte M\u00FCdigkeit (als unangenehmer Effekt)")),
                        react_1.default.createElement(native_base_1.Checkbox, { borderColor: "#3db384", colorScheme: 'green', value: 'cardioVascularProblems' },
                            react_1.default.createElement(native_base_1.Text, { ml: 2 }, "Herzkreislaufprobleme (Blutdruckabfall, Herzrasen, Schwindel, Unwohlsein)")),
                        react_1.default.createElement(native_base_1.Checkbox, { borderColor: "#3db384", colorScheme: 'green', value: 'motorLimitations' },
                            react_1.default.createElement(native_base_1.Text, { ml: 2 }, "Motorische Einschr\u00E4nkungen")),
                        react_1.default.createElement(native_base_1.Checkbox, { borderColor: "#3db384", colorScheme: 'green', value: 'sonstiges' },
                            react_1.default.createElement(native_base_1.Text, { ml: 2 }, "Sonstiges")),
                        prescriptionTemp.generalSideEffects.length !== 0 &&
                            // @ts-ignore
                            groupValues.includes('sonstiges') && (react_1.default.createElement(native_base_1.View, { style: FollowPrescription_style_1.styles.textAreaView },
                            react_1.default.createElement(atome_1.InputField, { style: [{ width: '100%', height: 100 }], multiline: true, onChange: value => handleInputFieldChange(value), value: prescriptionTemp.generalSideEffectsOther }))),
                        react_1.default.createElement(native_base_1.View, { style: FollowPrescription_style_1.styles.separator },
                            react_1.default.createElement(native_base_1.Checkbox, { borderColor: "#3db384", colorScheme: 'green', value: 'keine' },
                                react_1.default.createElement(native_base_1.Text, { ml: 2 }, "Nein, ich habe keine allgemeinen Nebenwirkungen"))))),
                react_1.default.createElement(native_base_1.HStack, { space: 10, mb: "10", justifyContent: "center" },
                    react_1.default.createElement(native_base_1.Button, { mt: "12", w: ['40%', '10%'], alignSelf: 'center', backgroundColor: '#fff', borderRadius: "3xl", _text: { color: '#3db384', fontWeight: 'bold', underline: true }, onPress: handleBackButton }, "Zur\u00FCck"),
                    react_1.default.createElement(native_base_1.Button, { isDisabled: isButtonDisabled, mt: "12", w: ['40%', '10%'], alignSelf: 'center', backgroundColor: isButtonDisabled ? '#3db38475' : '#3db384', borderRadius: "3xl", _text: { color: '#fff', fontWeight: 'bold' }, onPress: next }, "Weiter"))),
            react_1.default.createElement(AbortFUPModal_1.AbortFUPModal, { navigation: navigation, setCurrentPage: setCurrentPage, showFUPRModal: showFUPRModal, setShowFUPRModal: setShowFUPRModal }))));
}
exports.GeneralSideEffects = GeneralSideEffects;
